import { useState, useEffect, useRef, useCallback } from 'preact/hooks'

export function useResizeObserver(options) {
  const [entry, setEntry] = useState(null)
  const [node, setNode] = useState(null)
  const observer = useRef(null)

  const disconnect = useCallback(() => {
    if (observer.current) {
      observer.current.disconnect()
    }
  }, [])

  useEffect(() => {
    if (observer.current) disconnect()

    observer.current = new ResizeObserver(([entry]) => {
      setEntry(entry)
    }, options)

    const { current: currentObserver } = observer

    if (node) currentObserver.observe(node)

    return () => {
      currentObserver.disconnect()
    }
  }, [node, disconnect])

  return [setNode, entry]
}
